import api from "../../api";
import utils from "../../utils";
import regex from "../../regex";
import Lottie from "react-lottie-player";
import values from "../../values";
import anLogin from "../../../assets/animations/an-Login.json";
import * as Yup from "yup";

import React, { useContext, useEffect, useLayoutEffect } from "react";

import { IItem, Role } from "../../types/common.interface";
import { Col, Container, Row } from "react-bootstrap";
import {
  CustomButton2,
  CustomInput,
  CustomRadioButtonGroup,
  CustomTimer,
} from "../../components";

import "./index.scss";
import Column from "../../components/CustomView/Column";
import { useFormik } from "formik";
import validations from "../../validations";
import { Link, useNavigate, useResolvedPath } from "react-router-dom";
import dictionary from "../../dictionary";
import Context from "../../context";
import Navigation from "../../../website/screen/HomeScreen/Components/Navigation";
interface iData {
  phoneNumber: string;
  otp: string;
}

// const {
//   loadCaptchaEnginge,
//   LoadCanvasTemplate,
//   LoadCanvasTemplateNoReload,
//   validateCaptcha,
// } = require("react-simple-captcha");

const LoginScreen = () => {
  const navigate = useNavigate();
  const { userInfo } = useContext(Context.AppContext);
  console.log(userInfo);

  // useLayoutEffect(() => {
  //   window.location.href = `${dictionary.roleToUrl(
  //     String(userData?.result?.role)
  //   )}`;
  // }, []);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isOtpSend, setIsOtpSend] = React.useState<boolean>(false);
  // const [captchaValue, setCaptchaValue] = React.useState<string>("");
  // const [captchaError, setCaptchaError] = React.useState<string>("");
  // const [selectedRole, setSelectedRole] = React.useState<IItem | null>(
  //   values.topMenuItems.LOGIN_ROLE_ITEM[0]
  // );

  // ============================================== Use queries =======================================

  const formik = useFormik({
    initialValues: {
      userName: "",
      password: "",
    },
    validationSchema: Yup.object({
      userName: validations.yupValidations.userName,
      password: Yup.string().required("فیلد گذرواژه اجباری است"),
    }),
    onSubmit: async (values) => {
      const userData = await api.postMethod.common.login({
        ...values,
        // role: selectedRole?.value as Role,
      });
      utils.setLoginData({
        token: userData?.result?.accessToken,
        userId: userData?.result?.id,
        userType: userData?.result?.role,
      });
      console.log(userData?.result);

      if (userData?.result?.role) {
        window.location.href = `${dictionary.roleToUrl(
          String(userData?.result?.role)
        )}`;
      }
    },
  });

  // ============================================== functions =======================================

  // const onRoleChange = (item: IItem | null) => {
  //   setSelectedRole(item);
  // };

  const onSubmit = async () => {
    formik.submitForm();
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      onSubmit();
    }
  };

  // useEffect(() => {
  //   loadCaptchaEnginge(4, "lightgray", "black", "numbers"); // loadCaptchaEnginge(Number_Of_Captcha_Charcters, Background_Color, Font_Color, Special_Characters);
  // }, []);

  return (
    <>
      <Navigation />

      <section id="login-screen-container">
        <Container fluid>
          <Row>
            <Col lg={5}>
              <div className="left-side">
                <div className="login-card">
                  <h1>ورود به پنل</h1>
                  {/* <div
                  // className='role-holder'
                  style={{
                    pointerEvents: isOtpSend || isLoading ? "none" : "all",
                  }}
                >
                  <CustomRadioButtonGroup
                    menus={values.topMenuItems.LOGIN_ROLE_ITEM}
                    selected={selectedRole}
                    onClick={onRoleChange}
                    canNull={false}
                  />
                </div> */}
                  <div className="phone-number-holder">
                    <Row className="">
                      <Column medium={12}>
                        <div className="enter-number-container">
                          <CustomInput
                            name="userName"
                            id="userName"
                            inputClassName="username"
                            value={formik.values.userName}
                            onValueChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="نام کاربری"
                            placeHolder="نام کاربری"
                            textAlign="center"
                            error={
                              formik.errors.userName && formik.touched.userName
                            }
                            errorText={formik.errors.userName}
                          />
                        </div>
                      </Column>
                      <Column medium={12}>
                        <div className="enter-number-container">
                          <CustomInput
                            type="password"
                            name="password"
                            id="password"
                            inputClassName="password"
                            value={formik.values.password}
                            onValueChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            label="گذرواژه"
                            placeHolder="گذرواژه"
                            textAlign="center"
                            error={
                              formik.errors.password && formik.touched.password
                            }
                            onKeyDown={handleKeyDown}
                            errorText={formik.errors.password}
                            isPassword
                          />
                        </div>
                      </Column>
                    </Row>

                    {/* <Row className="captcha dropdown">
                    <Column medium={6}>
                    <div className="input-block">
                    <CustomInput
                    type="text"
                          id="captcha"
                          name="captcha"
                          value={captchaValue}
                          placeHolder={"عبارت امنیتی را وارد نمایید"}
                          onValueChange={(event) =>
                            setCaptchaValue(event.target.value)
                          }
                          onKeyDown={handleKeyDown}
                        />
                      </div>
                    </Column>
                    <Column medium={5} className="reload-captcha-column">
                      <LoadCanvasTemplate reloadText={`بارگذاری مجدد`} />
                    </Column>
                    <div className="error">{captchaError}</div>

                  </Row> */}
                  </div>
                  <CustomButton2
                    isLoading={isLoading}
                    onClick={onSubmit}
                    title={"ورود"}
                    type="primary"
                  />
                  <Row className="sign-up-text">
                    <Col>ثبت نام نکرده اید؟</Col>
                    <Col>
                      <Link to={"/panel/sign-up"}>
                        <CustomButton2
                          title={"ثبت نام"}
                          type="secondary"
                          onClick={() => false}
                        />
                      </Link>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
            <Col lg={7}>
              <div className="right-side">
                <Lottie
                  loop
                  animationData={anLogin}
                  play
                  style={{ width: "100%", height: "90%" }}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default LoginScreen;
